import React from "react";

const StaffModal = ({ open, staffList, newStaffName, setNewStaffName, handleAddStaff, handleDeleteStaff, onClose }) => {
  if (!open) return null;
  return (
    <div style={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", background: "rgba(0,0,0,0.3)", zIndex: 1000 }}>
      <div style={{ background: "#fff", padding: 24, borderRadius: 8, width: 400, margin: "100px auto", position: "relative" }}>
        <h3>担当者一覧</h3>
        <ul>
          {staffList.map(staff => (
            <li key={staff.id} style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
              <span style={{ flex: 1 }}>{staff.name}</span>
              <button type="button" style={{ marginLeft: 8 }} onClick={() => handleDeleteStaff(staff.dbId)}>削除</button>
            </li>
          ))}
        </ul>
        <div style={{ marginTop: 16 }}>
          <input type="text" value={newStaffName} onChange={e => setNewStaffName(e.target.value)} placeholder="新規担当者名" style={{ marginRight: 8 }} />
          <button type="button" onClick={handleAddStaff}>追加</button>
        </div>
        <button type="button" style={{ position: "absolute", top: 8, right: 8 }} onClick={onClose}>閉じる</button>
      </div>
    </div>
  );
};

export default StaffModal;
